import type { IChipModel } from '@/interfaces/models';
import { Point } from '@/models/Point';
import { TileType } from '@/models/TileTypes';
import { rotateSide } from '@/models/data/Rotation';
import { CircuitType, Side } from '@/schemas/common';
import { isStructureContiguous } from './structureContiguity';

/** Shared by every save route; invalid authoring remains a recoverable draft. */
export function bundleAdapterValidation(chip: IChipModel): string | undefined {
  if (chip.kind !== 'bundle-adapter') return;
  const manager = chip.structureCircuit.circuitModel.tileManagerModel;
  const pins = chip.interfaceLinks.filter(
    (link) =>
      link.tiles[CircuitType.ChipStructure]?.tileType === TileType.SingleInterface,
  );
  const ports = manager.tiles.filter(
    (tile) => tile.tileType === TileType.BundleInterface,
  );
  if (!pins.length) return 'Place a Single Interface for each signal.';
  if (pins.some((link) => !link.label.trim()))
    return 'Give every single interface a signal label.';
  if (!ports.length) return 'Place a Bundle Interface on the body edge for the cable.';
  if (!isStructureContiguous(manager)) return 'Join the body tiles edge to edge.';
  if (
    ports.some((port) => {
      const side = rotateSide(Side.LEFT, port.meta.rotation);
      const dx = side === Side.LEFT ? -1 : side === Side.RIGHT ? 1 : 0;
      const dy = side === Side.TOP ? -1 : side === Side.BOTTOM ? 1 : 0;
      return !!manager.get(new Point(port.location.x + dx, port.location.y + dy));
    })
  )
    return 'Draw bundle outward: rotate the bundle port to face empty space.';
}
